import React from "react";
import generateMeta from "../../../shared/services/metadataService";
import metaData from "../../../config/metaData";

/**
 * NotFound component displays a simple "Not found - 404" message when the requested page is not found.
 * @returns {JSX.Element} The NotFound component JSX
 */
const NotFound = (): JSX.Element => {
  return (
    <div
      data-testid="not-found-container"
      className="w-full h-screen pt-[10%] pb-[10%] bg-primary text-white flex flex-col justify-center items-center"
    >
      {generateMeta({
        title: metaData.notFound.title,
        description: metaData.notFound.description,
      })}
      <h1 className="text-[130px] md:text-[80px] sm:text-[60px] font-bold uppercase animate-opacity mb-0">
        404
      </h1>
      <p className="mt-0 font-bold text-[60px] md:text-[32px] sm:text-[26px] text-center">
        Page Missing in Action!
      </p>
    </div>
  );
};

export default NotFound;
